export default __webpack_public_path__ + "static/media/party-reis.44eacaa4.jpg";